import { LicenceAdditionalQuestionsSchemaType } from '../LicenceCountryAdditionalQuestions/schema'
import { NcdAdditionalQuestionsSchemaType } from '../NcdAdditionalQuestions/schema'
import { PreviousCancellationAdditionalQuestionsSchemaType } from '../PreviousCancellationAdditionalQuestions/schema'
import { StudentAdditionalQuestionSchemaType } from '../StudentAdditionalQuestions/schema'
import { PreviousCancellationYearSchemaType } from 'directFlow/pages/PreviousCancellationYear/schema'

import { report } from 'utils'

const additionalQuestionsSessionStorageKey = (quoteId: string) => `${quoteId}-additional-questions`

type AdditionalQuestionsSessionStorage = {
  previousCancellation: PreviousCancellationAdditionalQuestionsSchemaType
  previousCancellationYear: PreviousCancellationYearSchemaType
  licenceQuestions: LicenceAdditionalQuestionsSchemaType
  ncdQuestions: NcdAdditionalQuestionsSchemaType
  studentQuestions: StudentAdditionalQuestionSchemaType
}

//using session storage here allows us to easily store the default values
//this means a user can move backwards and forwards in their post-quote session
export const getAdditionalQuestionsSessionStorage = ({
  quoteId,
}: {
  quoteId: string
}): AdditionalQuestionsSessionStorage | undefined => {
  try {
    const sessionFormData = sessionStorage.getItem(additionalQuestionsSessionStorageKey(quoteId))

    const storedFormData = sessionFormData ? JSON.parse(sessionFormData) : undefined

    return storedFormData
  } catch (err) {
    report(err, 'Error retrieving additional questions session storage')
    return undefined
  }
}

export const patchAdditionalQuestionsSessionsStorage = ({
  quoteId,
  data,
}: {
  quoteId: string
  data: Partial<AdditionalQuestionsSessionStorage>
}) => {
  try {
    const sessionFormData = sessionStorage.getItem(additionalQuestionsSessionStorageKey(quoteId))

    const storedFormData = sessionFormData ? JSON.parse(sessionFormData) : undefined

    sessionStorage.setItem(
      additionalQuestionsSessionStorageKey(quoteId),
      JSON.stringify({ ...storedFormData, ...data }),
    )
  } catch (err) {
    report(err, 'Error updating additional questions session storage')
  }
}
